import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';
import FormService from '../../../core/services/FormService';

class CanDosListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      items: [],
      course: {},
    });
    this.form.setInitialValues({});
  }

  init = action((courseId) => {
    this.items = [];
    this.form.reset();

    this.courseId = courseId;
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: `/courses/${this.courseId}/can-dos`,
        apiVersion: 'V2',
      })
      .then(() => {
        if (this.fetch.data) {
          this.items = this.fetch.data;
        } else {
          this.items = [];
        }
      });
  });

  handleRemove = action((item) => {
    ConfirmationDialogService.show(
      'Delete Course Can Do',
      `You are about to delete the can do "${item.text}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            url: `/courses/${this.courseId}/can-dos/${item.id}`,
            method: 'delete',
            apiVersion: 'V2',
          })
          .then(() => {
            NotificationService.addNotification(`Can do"${item.text}" deleted successfully.`, 'success');
            this.load();
          });
      }
    );
  });
}

const service = new CanDosListService();

export default service;
